var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1Firmware(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 27v-4h-7v-5h-6v-7h-4v7h-8v-7h-4v7h-9v-7h-4v7h-5v5h-7v4h7v9h-7v4h7v9h-7v4h7v5h5v7h4v-7h9v7h4v-7h8v7h4v-7h6v-5h7v-4h-7v-9h7v-4h-7v-9h7zM54 54H22V22h32v32z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_Firmware.68afe553.svg";
export { SvgH1Firmware as ReactComponent };